var map = {
	"./webspecial_event_konzert_cn.mp4": 4452,
	"./webspecial_event_konzert_de.mp4": 8138,
	"./webspecial_event_konzert_en.mp4": 8002,
	"./webspecial_event_konzert_ja.mp4": 4788,
	"./webspecial_event_konzert_tr.mp4": 6097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6502;